import React, { useEffect } from 'react';

import cls from 'classnames';

import noop from 'lodash/noop';

import Button from '@ott/button';
import { l10n, l10nhtml } from '@ott/l10n';
import Modal, { CONTENT_SIZE } from '@ott/modal';
import KM from '@ott/utility-km';

import BackgroundGradient from '../../../BackgroundGradient';
import CardImage from '../../../CardImage';

import styles from './UpgradePromoModal.scss';

const modalContentOptions = {
  className: cls(styles.content),
  size: CONTENT_SIZE.SMALL,
};

type Props = {
  onClose: VoidFunction;
  isOpen?: boolean;
  preventUserCloseModal?: boolean;
  onAction?: VoidFunction;
};

const UpgradePromoModal = ({
  onAction = noop,
  isOpen = true,
  preventUserCloseModal,
  onClose,
}: Props) => {
  useEffect(() => {
    if (isOpen) {
      KM('Virtual_Card_Features_Upgrade_transition');
    }
  }, [isOpen]);

  const modalChildren = {
    body: (
      <>
        <BackgroundGradient />
        <div className={styles.wrapper} data-locator="virtual-card-upgrade-promo">
          <div className={styles.card}>
            <CardImage />
          </div>
          <div className={styles.title}>{l10n('virtualCard.upgradePromo.title')}</div>
          <div className={styles.options}>
            <p className={styles.optionTitle}>
              {l10n('virtualCard.upgradePromo.options.increasedOperationLimitValue')}
            </p>
            <p className={styles.optionText}>
              {l10n('virtualCard.upgradePromo.options.increasedOperationLimitText')}
            </p>
            <p className={styles.optionTitle}>
              {l10n('virtualCard.upgradePromo.options.increasedMonthlyLimitValue')}
            </p>
            <p className={styles.optionText}>
              {l10n('virtualCard.upgradePromo.options.increasedMonthlyLimitText')}
            </p>
          </div>
          <div className={styles.agreements}>{l10nhtml('virtualCard.upgradePromo.agreements')}</div>
          <div className={styles.button}>
            <Button
              onClick={onAction}
              withFullWidth={true}
              specificLocators="virtual-card-upgrade-promo-action"
            >
              {l10n('virtualCard.upgradePromo.action')}
            </Button>
          </div>
        </div>
      </>
    ),
  };

  return (
    <Modal
      isOpen={isOpen}
      fullScreenOnMobile={true}
      contentOptions={modalContentOptions}
      preventUserClose={preventUserCloseModal}
      onClose={onClose}
    >
      {modalChildren}
    </Modal>
  );
};

export default React.memo(UpgradePromoModal);
